<mat-form-field>
  <mat-label>Name</mat-label>
  <input type="text"
         aria-label="Name"
         matInput
         [formControl]="control"
         [matAutocomplete]="auto">
<mat-autocomplete (optionSelected)="change($event)" #auto="matAutocomplete">
  <mat-option *ngFor="let option of options" [value]="option.uuid">
    <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{option.uuid}}/20"> &nbsp;
      {{option.username}}
      </span>
  </mat-option>
</mat-autocomplete>
</mat-form-field>
